// extracted by mini-css-extract-plugin
export default {"App":"Support_App__3Fjlk","hr":"Support_hr__Vd7Mx","input":"Support_input__adJPp","button":"Support_button__lniP4"};